import trafficInfo from "./trafficInfo";

const trafficInfoService = [
    {
        matcher: 'trafficInfo',
        reply: config => {
            return [200, trafficInfo];
        }
    }
]

export default trafficInfoService;